import {
    defineRequest,
} from '@/lib/fetch-tools';
import { FissionResponse } from './types';
import { getRequestDefinitionType } from '@/lib/fetch-utils';

export const apiFinanceUserCoin = defineRequest<
  FissionResponse<{
    id: number;
    userid: number;
    usdt: number;
    tradeUsdt: number;
    usdtd: number;
    usdtb: string;
    btc: number;
    btcd: number;
    btcb: string;
    eth: number;
    ethd: number;
    ethb: string;
    username: string | null;
    companyId: number;
  }>,
  {
    uid: string;
  }
>('/api/pc/finance/userCoin');
export type ApiFinanceUserCoinType = getRequestDefinitionType<
  typeof apiFinanceUserCoin
>;

export const apiFinanceUserCoinTransfer = defineRequest<
  FissionResponse<{}>,
  {
    uid: number;
    amount: number;
    type: number;
  }
>('/api/pc/finance/usercoin/transfer');
export type ApiFinanceUserCoinTransferType = getRequestDefinitionType<
  typeof apiFinanceUserCoinTransfer
>;

// 返回false，交易量未完成，给弹窗
// 返回true ，交易量完成，不给弹窗
export const apiFinanceCodeAmount = defineRequest<
  FissionResponse<boolean>,
  {
    uid: string;
  }
>('/api/pc/finance/codeAmount');
export type ApiFinanceCodeAmountType = getRequestDefinitionType<
  typeof apiFinanceCodeAmount
>;


